"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTexts = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var next_intl_1 = require("next-intl");
var react_html_parser_1 = __importDefault(require("react-html-parser"));
var useTexts = function (category) {
    var lang = (0, next_intl_1.useLocale)();
    var prevLang = (0, react_1.useRef)(lang);
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.TEXTS,
        payload: {
            category: category,
            lang: lang.toLowerCase(),
        },
        onErrorRetry: function () { return false; },
    }), data = _a.data, isLoading = _a.isLoading, mutate = _a.mutate;
    (0, react_1.useEffect)(function () {
        if (prevLang.current !== lang) {
            mutate();
            prevLang.current = lang;
        }
    }, [lang, mutate]);
    return (0, react_1.useCallback)(function (key, variables) {
        var _a, _b;
        if (isLoading)
            return '';
        var preparedKey = key.toUpperCase();
        var result = ((_b = (((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.text) || {})) === null || _b === void 0 ? void 0 : _b[preparedKey]) || preparedKey;
        if (variables) {
            result = result.replace(/\{\{(\w+)\}\}/g, function (_, variableName) {
                return variables[variableName] !== undefined
                    ? variables[variableName]
                    : "{{".concat(variableName, "}}");
            });
        }
        return (0, react_html_parser_1.default)(result.replace(/\n/g, '<br/>'));
    }, [data, isLoading]);
};
exports.useTexts = useTexts;
